import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';
import { memo } from 'react';
import { headerActionDividerSx } from './header_action_styles.ts';

interface HeaderActionDividerProps {
  sx?: SxProps<Theme>;
}

export const HeaderActionDivider = memo(function HeaderActionDivider({ sx }: HeaderActionDividerProps) {
  return <Box aria-hidden sx={[headerActionDividerSx, ...(sx ? [sx] : [])] as SxProps<Theme>} />;
});
